<template>
  <a-form-item :label="label">
    <a-select
      style="width: 100%"
      allowClear
      :mode="mode"
      :filter-option="filterOption"
      class="select"
      show-search
      :loading="loading"
      @select="handleSelect"
      @change="handlerChange"
      :placeholder="placeholder"
      v-decorator="[field,{initialValue: mode === 'multiple' ? [] : null,rules: [{ required: required, message: `Please input your ${ label }`}] }]"
    >
      <span slot="dropdownRender" slot-scope="menu">
        <v-nodes :vnodes="menu" />
        <template v-if="is_add_extra_footer">
          <a-divider style="margin: 2px 0;"/>
          <a-button
            type="link"
            style=" cursor: pointer;"
            @mousedown="e => e.preventDefault()"
            @click="emitClicker"
          >
            <a-icon type="plus" />Create Practice Area
          </a-button>
        </template>
      </span>
      <a-select-option v-for="(item,index) in data" :value="item.id" :key="item.id">
        <template v-if="item.person || item.company">
          <template v-if="item.person">
            {{ item.person.first_name }} {{ item.person.last_name }}
          </template>
          <template v-else>
            {{ item.company.name }}
          </template>
        </template>
        <template v-else>
          {{ item.title ? item.title : item.first_name + ' ' + item.last_name }}
        </template>
      </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script>
import axios from "@/axios"
import Mixin from '@/views/mixin/mixin'

export default {
  name: "SelectOption",
  mixins: [Mixin],
  components:{
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  props:{
    url                : { type : String,default:'/account/list/' },
    label              : { type : String },
    field              : { type : String },
    method             : { type: String , default: 'post' },
    required           : {type: Boolean , default: false},
    is_initial_value   : {type: Boolean , default: false},
    mode               : { type: String, default: 'default' },
    placeholder        : { type: String , default:'notification' },
    is_add_extra_footer: { type: Boolean , default:false }
  },
  data(){
    return{
      data:[],
      loading: false,
    }
  },
  computed:{
    getUser(){
      return JSON.parse(localStorage.getItem('user'))
    }
  },
  methods:{
    async getMatter() {
      try {
        this.loading = true
        if (this.method == 'post') {
          const { data } = await axios.post(this.url, { limit: 100 })
          this.data = data.rows
          this.$emit('loaded', data.rows)
        } else {
          const { data } = await axios.get(this.url)
          this.data = data
          this.$emit('loaded', data)
        }
      } catch (e) {
        throw e
      } finally {
        this.loading = false
      }
    },
    handleSelect(value){
      this.$emit('SelectUser',value)
    },
    emitClicker(){
      this.$emit('emitClicker')
    },
    handlerChange(value) {
      this.$emit('change', value)
    }

  },
  mounted() {
    this.getMatter()
  },
}
</script>

<style scoped>

</style>
